export default __webpack_public_path__ + "static/tellowQRCode-7ff7437658121f3db7edd79170dc8ef2da132e853366052f5c9dbdb32b10c59b.png";